import React from 'react';
import { useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';

export const Placeholder: React.FC = () => {
  const location = useLocation();
  const pageName = location.pathname.split('/').pop()?.replace(/_/g, ' ') || 'Pagina';

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 mb-6">
        <Construction className="w-10 h-10" />
      </div>
      <h1 className="text-2xl font-bold capitalize">{pageName}</h1>
      <p className="text-muted-foreground mt-2 max-w-md">
        Questa pagina è attualmente in fase di sviluppo. Torna presto per vedere le nuove funzionalità!
      </p>
    </div>
  );
};
